import * as validator from "validator";

export function isEmail(input: string): boolean {
	return validator.isEmail(input) && input[input.indexOf("@") - 1] != "."
}
